module.exports = __webpack_public_path__ + "46ea657bf37669a22c87fb4e70ba79d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-22.png
// module id = 2253
// module chunks = 0